import { LocationNumbersService } from '../../../services'

const fetchPhoneNumbers = async function (
  { commit, state, getters, dispatch },
  config
) {
  let tableConfig

  const { companyId, locationId, payload, getPaginatedDataOnly = false } = config

  const twilioAccountId = state.locationTwilio?.id
  const isUnderGHL = state.locationTwilio?.underGHLAccount ?? state.locationTwilio?.under_ghl_account
  /**
   * If payload is not provided, then we are fetching
   * the phone numbers from the state table
   */
  if (!payload) {
    tableConfig = {
      limit: state.table?.limit,
      page: state.table?.currentPage,
      query: state.table?.searchText ?? '',
    }
  }

  const table = payload ?? tableConfig

  if (getPaginatedDataOnly) {
    const result = await dispatch('fetchLocalPhoneNumbers', {
      paginationConfig: table,
    })
    return Promise.resolve(result)
  }

  commit('startLoading')
  try {
    const data = await LocationNumbersService.getInboundPhoneNumbers(
      locationId,
      twilioAccountId
    )

    if (data && data.incoming_phone_numbers) {
      if(isUnderGHL) {
        try {
          await dispatch('fetchPhoneNumbersA2PStatus', {locationId, companyId})
        } catch(error) {
          console.error(error)
        }
      }

      commit(
        'setPhoneNumbers',
        getters.getCorrectedPhoneNumbers(data.incoming_phone_numbers)
        )
      commit('setPhoneNumbersLookupTable', 'phone_number')
      commit('generateMapPhoneNumberSID')
      commit('setTableRecordsCount', data.incoming_phone_numbers?.length)
      commit('setTable', payload ?? tableConfig)

      const result = getters.getPaginatedPhoneNumbers
      return Promise.resolve({ incoming_phone_numbers: result })
    }

    commit('setPhoneNumbers', [])
    return Promise.resolve({ incoming_phone_numbers: [] })
  } catch (error) {
    return Promise.reject(error)
  } finally {
    commit('stopLoading')
  }
}

export default fetchPhoneNumbers
